import { Link } from 'react-router-dom';
import { Logo } from '@/components/common/Logo';
import { Disclaimer } from '@/components/common/Disclaimer';
import { PlatformIcon } from '@/components/icons/PlatformIcon';
import { ROUTES } from '@/constants/routes';

const CONTENT_TYPES = ['Reels', 'Feed posts & photos', 'IGTV', 'Video'];

const PRODUCT_LINKS = [
  { label: 'Dashboard', to: ROUTES.dashboard },
  { label: 'Features', to: '/#features' },
  { label: 'How it works', to: '/#how-it-works' },
  { label: 'FAQ', to: '/#faq' },
];

const LEGAL_LINKS = [
  { label: 'About', to: ROUTES.about },
  { label: 'Privacy Policy', to: ROUTES.privacy },
  { label: 'Terms of Service', to: ROUTES.terms },
  { label: 'DMCA Notice', to: ROUTES.dmca },
];

export function Footer() {
  return (
    <footer className="border-t border-white/5 bg-surface-raised/40">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div className="space-y-4">
            <Logo />
            <p className="max-w-xs text-sm leading-relaxed text-zinc-500">
              Download, extract and transform public Instagram Reels, posts and video — fast,
              secure and watermark-free.
            </p>
            <Disclaimer />
          </div>

          <div>
            <h3 className="text-sm font-semibold text-zinc-200">Product</h3>
            <ul className="mt-4 space-y-2.5">
              {PRODUCT_LINKS.map((link) =>
                link.to.startsWith('/#') ? (
                  <li key={link.label}>
                    <a href={link.to} className="text-sm text-zinc-500 transition-colors hover:text-zinc-200">
                      {link.label}
                    </a>
                  </li>
                ) : (
                  <li key={link.label}>
                    <Link to={link.to} className="text-sm text-zinc-500 transition-colors hover:text-zinc-200">
                      {link.label}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-zinc-200">Legal</h3>
            <ul className="mt-4 space-y-2.5">
              {LEGAL_LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-zinc-500 transition-colors hover:text-zinc-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-zinc-200">What you can download</h3>
            <ul className="mt-4 space-y-2.5">
              {CONTENT_TYPES.map((label) => (
                <li key={label} className="flex items-center gap-2 text-sm text-zinc-500">
                  <PlatformIcon platform="instagram" className="h-4 w-4" />
                  {label}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/5 pt-6 sm:flex-row">
          <p className="text-xs text-zinc-600">
            © {new Date().getFullYear()} Instagram Media Downloader. All rights reserved.
          </p>
          <p className="text-xs text-zinc-600">Processes publicly accessible content only.</p>
        </div>
      </div>
    </footer>
  );
}
